import { FormCheckBox, NumericFormInput } from "../../../../../../components/Forms";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box, Text } from "@chakra-ui/react";
import { nonNumericSymbols, translateSubElementString } from "../../../../../../utils";

function ManualInput({ register, errors, control, watch, setValue, isPreview }) {
  const { t: globalTranslation } = useTranslation("translation");
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3.inputs"
  });
  const manualInputValue = watch("manualInputOfEmissions", false);
  const notesValue = watch("notes");

  const handleManualInputChange = (isManualInput) => {
    if (isManualInput) {
      const newNotesValue = notesValue && notesValue !== "" ?
        !notesValue.includes(t("manualInputNote")) ?
          `${notesValue}\n${t("manualInputNote")}` : notesValue :
        t("manualInputNote");
      setValue("notes", newNotesValue, { shouldDirty: true });
    } else {
      const newNotesValue = notesValue.replace(t("manualInputNote"), "").trim();
      setValue("notes", newNotesValue, { shouldDirty: true });
      setValue("totalCo2Emissions", null, { shouldDirty: true });
    }
  };

  return (
    <Box marginBlock={4} display="flex" flexFlow="column" gap={3}>
      <FormCheckBox
        label={t("manualInputCheckboxLabel")}
        {...register("manualInputOfEmissions")}
        isDisabled={isPreview}
        errors={errors}
        control={control}
        controlProps={{
          onClick: (e) => {
            if (typeof e.target?.checked !== "undefined") {
              handleManualInputChange(e.target?.checked);
            }
          }
        }}
      />
      {manualInputValue === true ?
        <>
          <Text fontSize="lg" fontWeight="bold" marginBottom={3}>
            {translateSubElementString("organizationQuestionnaire.scope3.inputs.manualInputDetails")}
          </Text>
          <NumericFormInput
            label={translateSubElementString("organizationQuestionnaire.scope3.inputs.manualInputLabel")}
            {...register("totalCo2Emissions", {
              required: manualInputValue === true ? globalTranslation("errors.required") : false
            })}
            errors={errors}
            onKeyDown={(e) => nonNumericSymbols.includes(e.key) && e.preventDefault()}
            disabled={isPreview}
          />
        </>
       : null
      }
    </Box>
  )
}

export default ManualInput;